<template>
    <div class="moeny-index">
        <div class="header">
          <div class="content">
            <div class="name">{{detail.name}}</div>
            <!-- <div class="number">尾号8015储蓄卡</div> -->
          </div>
        </div>
        <!-- 输入提现金额 -->
        <div class="amount-body">
            <Form @submit="onSubmit">
                <div class="amount-title">消费金额</div>
                <div class="amount-count">
                    <span class="yuan">￥</span>
                    <Field autofocus name="money" type="number" size="large" @touchstart.native.stop="show = true" onfocus="this.blur()" v-model="money"  />
                </div>
                <CouponCell
                    v-if="coupons.length>0"
                  :coupons="coupons"
                  :chosen-coupon="chosenCoupon"
                  @click="gogo"
                />
                <Button :disabled="loading" :loading="loading" size="large"  type="info" native-type="submit">
                    确认付款
                </Button>
            </Form>
        </div>

        <NumberKeyboard
                :show="show"
                theme="custom"
                extra-key="."
                @input="onInput"
                @close="show=false"
                @delete="deletenum"
                @blur="show = false"
                close-button-text="完成"
        />
        <Popup
          v-model="showList"
          round
          position="bottom"
          style="height: 90%; padding-top: 4px;"
        >
          <CouponList
            :show-exchange-bar="false"
            :coupons="coupons"
            :chosen-coupon="chosenCoupon"
            @change="onChange"
            @exchange="onExchange"
          />
        </Popup>

        <Popup
          v-model="showOrder"
          round
          position="center"
          :close-on-click-overlay="false"
          style="padding: 4px 0 10px;width: 85%;"
        >
          <div class="wet-pay">
            <div class="wet-title"><img src="https://moveclub-file.oss-cn-hangzhou.aliyuncs.com/mpms/20200620/1592621159-5eed78671d704.png" alt="">微信支付</div>
            <div>
                订单号：{{orderdetail.orderno}}
            </div>
            <div v-if="orderdetail.coupon&&orderdetail.coupon.sub_price>0">
                优惠券减免：¥<span>{{orderdetail.coupon.sub_price/100}}</span>元
            </div>
            <div v-if="orderdetail.offprice!=0">
                场馆减免：¥<span>{{orderdetail.offprice/100}}</span>元
            </div>
            <div>
                消费金额：¥<span>{{orderdetail.price/100}}</span>元
            </div>
            <div>
                实际支付：¥<span>{{orderdetail.payprice/100}}</span>元
            </div>
            <Button @click="pay" size="large"  type="info" class="btn">
                立刻支付
            </Button>
          </div>
        </Popup>

    </div>
</template>
<script>

    import {isWeiXin} from "@/libs/utils";
    import {getDetail,available,payprepayorder,paypayorder} from '@/libs/api.js'
    import {NumberKeyboard, Field,Form,Button,CouponCell, CouponList,Popup} from "vant";
    import { getLastRouter, goBack, setStorage, islogin, userinfo,getStorage} from '@/libs/utils'
    export default {
        name: "index",
        data() {
            return {
                show: false,
                loading: false,
                money:'',
                stid:'',
                detail:{},
                showList:false,
                showOrder:false,
                orderdetail:{},
                shipment:{},
                coupons:[],
                chosenCoupon: 0,
            };
        },
        components: {
            NumberKeyboard,
            Field,
            Form,
            Button,CouponCell, CouponList,Popup
        },
        methods: {
            onSubmit:function (e) {
                let {money} = e
                if(money*1<=0){
                  this.$dialog.alert({
                    title: "提示",
                    message: '输入金额不能小于0'
                  });
                  return
                }
                this.loading = true
                this.paypre()
            },
            getprice: function () {
              if(this.money.length==0) this.money = 0
                available({price:this.money,stid:this.stid}).then((res)=>{
                  if(res.status==200){
                    let list = res.data
                    let coupons = []
                    let timestamp = Date.parse(new Date());
                    let start = timestamp/1000
                    list.forEach((row,index)=>{
                      coupons.push({
                        id:row.id,
                        name:row.title,
                        startAt:start,
                        endAt:row.end_time*1,
                        value:row.sub_price*1,
                        condition: '公益配送券',
                        valueDesc:row.sub_price/100,
                        unitDesc:'元'
                      })
                    })
                    this.coupons = coupons 
                  }
                })
            },
            gogo: function () {
              this.getprice()
              this.showList = true

            },
            paypre: function () {
              let query = {
                stid:this.stid,
                price:this.money*100
              }
              if(this.coupons.length>0&&this.chosenCoupon!=-1){
                let couponcodeid = this.coupons[this.chosenCoupon].id
                query = {
                  stid:this.stid,
                  price:this.money*100,
                  couponcodeid
                }
              }
              payprepayorder(query).then((res)=>{
                  if(res.status*1==200){
                      this.orderdetail = res.data
                      this.showOrder = true
                  }
              })
            },
            pay: function () {
                paypayorder({orderno:this.orderdetail.orderno}).then((res)=>{
                    if(res.status*1 == 200){
                        // console.log(res)
                        if(res.data.shipment&&res.data.shipment.return_code&&res.data.shipment.return_code=='FAIL'){
                          this.$dialog.alert({message:res.data.shipment.return_msg})
                        } else {
                          this.confrimPay(res.data.shipment)
                        }
                        // 
                    }
                })
            },
            onInput: function (value) {
              this.money += value
              //保证只有出现一个.而没有多个.     
              // this.money = this.money.toString().replace(/^\./g,'');
              // 限制只能输入一个小数点及两位小数
              this.money = this.money.toString().match(/^\d*(\.?\d{0,2})/g)[0] || null
              this.getprice()
            },
            deletenum: function () {
                let flag = true
                if (flag) {
                    // 删除掉字符串最后一个
                    this.money = this.money.substring(0, this.money.length - 1)
                    this.getprice()
                    if (this.money.length === 0) {
                      flag = false
                      return false
                    }
                }
            },
            getDetail: function () {
                getDetail({stid:this.stid}).then((res)=>{
                    if(res.status*1==200){
                        this.detail =  res.data.data
                    }
                })
            },
            //确认付款
            confrimPay(wxpayconfig){
              wxpayconfig.jumpurl    =    encodeURIComponent('http://'+window.location.host+'/paysuccess');
              let jumpurl =   "https://store.moveclub.cn/wechatpay.php?info="+JSON.stringify(wxpayconfig);
              window.location.href    =   jumpurl
            },
            close: function () {
              console.log(111)
              // this.loading = false
            },
            onChange(index) {
              this.showList = false;
              this.chosenCoupon = index;
            },
            onExchange(code) {
              console.log(code)
              // this.coupons.push(coupon);
            },
        },
        mounted() {
            this.$nextTick(() => {
              this.isweixin = isWeiXin()
              this.stid = window.localStorage.getItem('stid');
              this.getDetail()
            })

        }


    };
</script>
<style scoped lang="less">
.moeny-index{
  height: 100%;
  margin:60px 20px 20px;
  background:#ffffff;
  border-radius:10px;
  font-size: 16px;
  // 选择银行卡
  .header{
    display: flex;
    align-items:center;
    justify-content: center;
    padding: 10px;
    margin-bottom: 10px;
    background-color: #fdfdfd;
    .name{
        font-size: 22px;
        padding-bottom: 10px;
    }
    .number{
        font-size:18px;
        color: #808080;
    }
  }
  // 输入提现金额
  .amount-body{
    padding: 14px 10px;
    background-color: #fff;
    .amount-title{
      color: #333;
    }
    .amount-count{
      display: flex;
      align-items: center;
      padding: 10px 0;
      font-size:20px;
      .van-cell {
        font-size:25px;
      }
      .yuan{
        width:50px;
        text-align: center;
        font-size: 30px;
      }
      // .count{}
    }
  }
  .van-popup{
    .wet-pay{
      display:flex;
      flex-direction: column;
      padding: 30px 10px 10px;
      >div{
        font-size:16px;
        color: #808080;
        padding-bottom:10px;
        word-wrap: break-word;
        word-break: break-all;
      }
      >div>span{
        font-weight: 500;
        font-size:32px;
        color:#000000;
      }
      .wet-title{
        align-self:center;
        display:flex;
        align-items:center;
        justify-content: center;
        font-size:22rpx;
        color:#333333;
      }
      .wet-title>img{
        width: 30px;
        height:30px;
      }
      .btn{

      }
    }
  }
}
</style>
